import { uniqueId } from 'lodash';
import { DateTime } from 'luxon';

import Message, { MessageType } from 'dashboard/lib/interfaces/Message';
import Action from 'lib/interfaces/Action';

export enum MessagesActionType {
  ShowMessage = 'messages/SHOW_MESSAGE',
  RemoveMessage = 'messages/REMOVE_MESSAGE',
  ClearMessage = 'messages/CLEAR_MESSAGE',
  ClearMessages = 'messages/CLEAR_MESSAGES',
  ClearMessagesOnRouteChange = 'messages/CLEAR_MESSAGES_ON_ROUTE_CHANGE',
}

type ShowMessage = Action<MessagesActionType.ShowMessage, Message>;

export function showMessage(
  message: string,
  messageType: MessageType = MessageType.Failure,
  persist?: boolean,
  expiresAt?: string,
): ShowMessage {
  return {
    payload: {
      id: uniqueId('message'),
      message,
      messageType,
      persist,
      expiresAt: expiresAt ?? DateTime.local().plus({ seconds: 8 }).toISO(),
    },
    type: MessagesActionType.ShowMessage,
  };
}

type ClearMessage = Action<MessagesActionType.ClearMessage, { id: string }>;

export function clearMessage(id: string): ClearMessage {
  return {
    payload: {
      id,
    },
    type: MessagesActionType.ClearMessage,
  };
}

type ClearMessages = Action<MessagesActionType.ClearMessages>;

export function clearMessages(): ClearMessages {
  return {
    type: MessagesActionType.ClearMessages,
  };
}

type ClearMessagesOnRouteChange = Action<MessagesActionType.ClearMessagesOnRouteChange>;

export function clearMessagesOnRouteChange(): ClearMessagesOnRouteChange {
  return {
    type: MessagesActionType.ClearMessagesOnRouteChange,
  };
}

export type MessagesActions =
  | ShowMessage
  | ClearMessage
  | ClearMessages
  | ClearMessagesOnRouteChange;
